import { createRouter, createWebHistory } from 'vue-router';
import NotFound from './pages/NotFound';

import ResourcesRoutes from './modules/resources/resources.routes';

import JwtService from './services/jwt.service';

import store from '@/app.store.js';

const routes = [
  ...ResourcesRoutes,
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { left: 0, top: 0 };
    }
  },
});

router.beforeEach(async (to, from, next) => {
  if (!to.meta.isPublic) {
    if (!store.state.user.isAuthenticated) {
      const sessionToken = JwtService.getSessionToken();
      if (sessionToken) {
        await store.dispatch('setApiKey');
      } else {
        return next({ name: 'login' });
      }
    }
    if (!store.state.global.appReady) {
      await store.dispatch('loadAppData');
    }
    next();
  } else {
    next();
  }
});

export default router;
